<template lang="pug">
  app-modal.modalVincularPessoa(
    titulo="Vincular pessoa",
    @closeModal="cancelar",
    :width="500"
  )
    template(slot="body")
      el-row
        el-col
          app-label(
            label="Informe o CPF/CNPJ da pessoa que deseja inserir para acompanhar o processo.",
            :required="false"
          )
          validation-observer(ref='observer' tag='form')
            validation-provider(rules="required", v-slot="{ errors }", name="cpfCnpj" mode="lazy")
              app-label(label="CPF/CNPJ:")
              el-input.input(
                name="cpfCnpj",
                v-mask="['###.###.###-##', '##.###.###/####-##']"
                v-model.trim="cpfCnpj",
                :class="{'erro' : errors.length}"
                placeholder="CPF/CNPJ"
              )
              span.help.erro {{ errors[0] }}
          validation-observer(ref='uploadObserver' tag='form')
            validation-provider(rules="required", v-slot="{ errors }")
              div
                h4 Anexar Procuração
                app-anexo(
                  id="upload-documentos-pessoas-vinculadas"
                  @removeFile="removeFile",
                  @uploadFile="uploadFile",
                  :exibirDownload="false",
                  :files="anexos",
                  :fileType="['pdf']",
                  v-model="anexos",
                  :errors="errors"
                )
        el-col
          span.pessoas Lista de pessoas que acompanham o processo
          div.list(v-for="pessoa in this.naoExclui()")
              span {{pessoa.nomeRazaoSocial}}
          div.list(v-for="pessoa in this.exclui()")
              span {{pessoa.nomeRazaoSocial}}
              el-button(
                @click="removerPessoa(pessoa)",
                type="text").botao
                i.material-icons.icon close
    template(slot="footer")
      div.buttons
        el-button.cancelarButton(@click="cancelar")
          i.fas.fa-times
          span  &nbsp Cancelar
        el-button(
          type="primary",
          @click="VincularPessoa"
        )
          i.fas.fa-check
          span &nbsp Confirmar
</template>
<script>
import AppModal from '@/components/AppModal'
import axios from '@/utils/api'
import AppNotificacao from '@/components/mixins/AppNotificacao'
import AppLabel from '@/components/AppLabel'
import AppAnexo from '@/components/AppAnexo'
import { mapGetters } from 'vuex'
export default {
  components: {
    AppModal,
    AppLabel,
    AppAnexo
  },
  mixins: [AppNotificacao],

  props: {
    processo: {
      required: true
    }
  },
  data () {
    return {
      cpfCnpj: '',
      interessado: '',
      cpfCnpjInteressado: null,
      pessoas: [],
      numeroProtocolo: null,
      anexos: [],
      vinculo: {}
    }
  },
  computed: {
    ...mapGetters({
      usuario: 'auth/usuarioLogado'
    }),
    isInteressado: {
      get () {
        return this.usuario.pessoa.cpfCnpj === this.cpfCnpjInteressado
      }
    }
  },
  created () {
    this.cpfCnpjInteressado = this.processo.cpfCnpjInteressado
    this.pessoas = this.processo.pessoas
    this.numeroProtocolo = this.processo.numeroProtocolo
  },

  methods: {
    cancelar () {
      this.cpfCnpj = ''
      this.$refs.observer.reset()
      this.$refs.uploadObserver.reset()
      this.$emit('cancelar')
    },

    async uploadFile (file) {
      this.anexos.push({ key: file.response, nome: file.name })
    },

    removeFile (file) {
      const arquivo = this.anexos.findIndex(obj => obj === file)
      this.anexos.splice(arquivo, 1)
    },

    naoExclui () {
      const naoExclui = []
      if (this.usuario.pessoa.cpfCnpj === this.cpfCnpjInteressado) {
        this.pessoas.forEach(pessoa => {
          if (pessoa.cpfCnpj === this.cpfCnpjInteressado) {
            naoExclui.push(pessoa)
          }
        })
      } else {
        this.pessoas.forEach(pessoa => {
          if (pessoa.cpfCnpj !== this.usuario.pessoa.cpfCnpj) {
            naoExclui.push(pessoa)
          }
        })
      }
      return naoExclui
    },
    exclui () {
      const exclui = []
      if (this.usuario.pessoa.cpfCnpj === this.cpfCnpjInteressado) {
        this.pessoas.forEach(pessoa => {
          if (pessoa.cpfCnpj !== this.cpfCnpjInteressado) {
            exclui.push(pessoa)
          }
        })
      } else {
        this.pessoas.forEach(pessoa => {
          if (pessoa.cpfCnpj === this.usuario.pessoa.cpfCnpj) {
            exclui.push(pessoa)
          }
        })
      }
      return exclui
    },
    async VincularPessoa () {
      const result = await this.$refs.observer.validate()
      const resultUploadObserver = await this.$refs.uploadObserver.validate()

      if (!result && !resultUploadObserver) {
        this.showNotificacao(
          this.$messages.TIPO_WARNING,
          this.$messages.TITULO_WARNING,
          'É obrigatório informar o CPF/CNPJ do procurador e anexar a procuração.'
        )
        return
      } else if (!resultUploadObserver) {
        this.showNotificacao(
          this.$messages.TIPO_WARNING,
          this.$messages.TITULO_WARNING,
          'É obrigatório anexar a procuração.'
        )
        return
      } else if (!result) {
        this.showNotificacao(
          this.$messages.TIPO_WARNING,
          this.$messages.TITULO_WARNING,
          'Informe um CPF/CNPJ da pessoa que vai acompanhar o processo.'
        )
        return
      }

      try {
        const protocolo = this.numeroProtocolo

        this.anexos.map(anexo => {
          this.vinculo = {
            cpfCnpj: this.cpfCnpj,
            protocolo: protocolo,
            documento: {
              key: anexo.key,
              nome: anexo.nome,
              tipo: {
                codigo: 'PROCURACAO',
                id: 240
              },
              isFormatKey: false
            }
          }
        })

        await axios({
          method: 'POST',
          url: 'processo/syncPessoa',
          data: this.vinculo
        })

        this.showNotificacao(
          this.$messages.TIPO_SUCCESS,
          this.$messages.TITULO_SUCCESS,
          'Pessoa adicionada'
        )
        this.atualizarProcesso()
        this.cancelar()
      } catch (error) {
        if (error !== '') {
          this.showNotificacao(
            this.$messages.TIPO_WARNING,
            this.$messages.TITULO_WARNING,
            error
          )
        }
      }
    },
    async removerPessoa (pessoa) {
      try {
        await axios({
          method: 'POST',
          url: `processo/remove/syncPessoa`,
          data: {...pessoa, protocolo: this.numeroProtocolo}
        })
        this.showNotificacao(
          this.$messages.TIPO_SUCCESS,
          this.$messages.TITULO_SUCCESS,
          'Pessoa deletada'
        )
        this.atualizarProcesso()
        this.cancelar()
      } catch (error) {
        if (error !== '') {
          this.showNotificacao(
            this.$messages.TIPO_WARNING,
            this.$messages.TITULO_WARNING,
            error
          )
        }
      }
    },
    pessoasSemInterressado () {
      const pessoasSemInterressado = []
      this.pessoas.forEach(pessoa => {
        if (pessoa.cpfCnpj !== this.cpfCnpjInteressado) {
          pessoasSemInterressado.push(pessoa)
        }
      })
      return pessoasSemInterressado
    },
    async atualizarProcesso () {
      this.$emit('atualizarProcesso')
    }

  }
}
</script>
<style lang="scss" scoped>
.buttons {
  display: flex;
  justify-content: space-between;
}
.cancelarButton:hover,
.cancelarButton:focus {
  background-color: #fef0f0;
  color: #f56c6c;
  border-color: #fbc4c4;
}
.botao {
  border: none;
  padding: 0;
  .icon {
    font-size: 20px;
    color: red;
  }
}
.list {
  display: flex;
  align-items: center;
  padding: 12px 0px;
  justify-content: space-between;
}
.interressado {
  color: #909399;
}

@media (max-width: 780px) {
  .modalVincularPessoa {
    position: fixed;
    width: 365px;
  }
}
</style>



// WEBPACK FOOTER //
// src/screens/central/processos/VincularPessoa.vue